var _defs, _path, _rect, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNamaz4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Namaz-4_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 89.1 160.63"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Namaz-4_svg__cls-1,.Namaz-4_svg__cls-2{fill:#fdb515;stroke:#c4820e;stroke-miterlimit:10}.Namaz-4_svg__cls-2{fill:none;stroke-width:.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-1",
    d: "M185.3 212.44h-19a2.82 2.82 0 00.29-.18 20.24 20.24 0 0017.72-20.07v-33.5a20.24 20.24 0 00-13.38-19v-9.9a30 30 0 10-13.75 0v9.9a20.24 20.24 0 00-13.37 19v33.5a20.29 20.29 0 001.34 7.21l-32.24 6.78a8.76 8.76 0 00-6.76 10.37 8.73 8.73 0 006 6.57 8.74 8.74 0 008.53 6.82h64.62a8.75 8.75 0 000-17.5z",
    transform: "translate(-105.45 -69.81)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "Namaz-4_svg__cls-1",
    x: 154.12,
    y: 150.17,
    width: 16.01,
    height: 52.03,
    rx: 8.01,
    transform: "rotate(-177.48 108.629 142.44)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "Namaz-4_svg__cls-1",
    x: 133.06,
    y: 170.62,
    width: 16.01,
    height: 53,
    rx: 8.01,
    transform: "rotate(84.32 126.89 103.979)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M134.8 92.06s.73-8.21 1.36-10.32c4.31-14.58 20.93-15.73 26.41-2.21.92 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M135.54 92.06s.74-8.21 1.36-10.32c4.32-14.58 20.94-15.73 26.42-2.21.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M136.41 92.06s.74-8.21 1.36-10.32c4.32-14.58 20.94-15.73 26.42-2.21.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M137.28 92.06s.74-8.21 1.36-10.32C143 67.16 159.58 66 165.06 79.53c.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M138.15 92.06s.74-8.21 1.36-10.32c4.32-14.58 20.94-15.73 26.42-2.21.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M139.27 92.06s.74-8.21 1.36-10.32C144.94 67.16 161.57 66 167 79.53c.92 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M140.39 92.06s.73-8.21 1.36-10.32c4.31-14.58 20.93-15.73 26.41-2.21.92 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M141.5 92.06s.74-8.21 1.37-10.32c4.31-14.58 20.93-15.73 26.41-2.21.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M142.25 92.06s.74-8.21 1.36-10.32C147.93 67.16 164.55 66 170 79.53c.92 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M143.37 92.06s.73-8.21 1.36-10.32C149 67.16 165.66 66 171.14 79.53c.92 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M144.36 92.06s.74-8.21 1.36-10.32C150 67.16 166.66 66 172.14 79.53c.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M145.23 92.06s.74-8.21 1.36-10.32C150.91 67.16 167.53 66 173 79.53c.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M146 92.06s.73-8.21 1.36-10.32c4.31-14.58 20.93-15.73 26.41-2.21.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M146.72 92.06s.74-8.21 1.36-10.32C152.4 67.16 169 66 174.5 79.53c.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M147.84 92.06s.74-8.21 1.36-10.32c4.32-14.58 20.94-15.73 26.41-2.21.92 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M148.58 92.06s.74-8.21 1.37-10.32c4.31-14.58 20.93-15.73 26.41-2.21.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M149.7 92.06s.74-8.21 1.36-10.32C155.38 67.16 172 66 177.48 79.53c.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M150.45 92.06s.73-8.21 1.36-10.32c4.31-14.58 20.93-15.73 26.41-2.21.92 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M151.32 92.06s.73-8.21 1.36-10.32C157 67.16 173.61 66 179.09 79.53c.92 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M152.19 92.06s.73-8.21 1.36-10.32C157.86 67.16 174.48 66 180 79.53c.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M153.06 92.06s.73-8.21 1.36-10.32c4.31-14.58 20.93-15.73 26.41-2.21.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M154.17 92.06s.74-8.21 1.36-10.32C159.85 67.16 176.47 66 182 79.53c.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M155.29 92.06s.74-8.21 1.36-10.32C161 67.16 177.59 66 183.07 79.53c.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M156 92.06s.73-8.21 1.36-10.32c4.31-14.58 20.93-15.73 26.41-2.21.92 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M157.15 92.06s.74-8.21 1.37-10.32c4.31-14.58 20.93-15.73 26.41-2.21.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M158.27 92.06s.74-8.21 1.36-10.32C164 67.16 180.57 66 186.05 79.53c.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M159.27 92.06s.73-8.21 1.36-10.32C164.94 67.16 181.56 66 187 79.53c.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M160.14 92.06s.73-8.21 1.36-10.32c4.31-14.58 20.93-15.73 26.41-2.21.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M160.88 92.06s.74-8.21 1.36-10.32c4.32-14.58 20.94-15.73 26.41-2.21.92 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M161.63 92.06s.73-8.21 1.36-10.32c4.31-14.58 20.93-15.74 26.41-2.21.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M162.74 92.06s.74-8.21 1.36-10.32c4.32-14.58 20.9-15.74 26.42-2.21.91 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M163.49 92.06s.74-8.21 1.36-10.32c4.31-14.58 20.93-15.73 26.41-2.21.92 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-4_svg__cls-2",
    d: "M163.49 92.06s.74-8.21 1.36-10.32c4.31-14.58 20.93-15.73 26.41-2.21.92 2.26 2 12.53 2 12.53z",
    transform: "translate(-105.45 -69.81)"
  })));
}

export default SvgNamaz4;